
import Vue from "vue";
import { Component } from "vue-property-decorator";
import RevisionsList from "@/components/Reusable/Revisions/RevisionsList.vue";
import { PresetsRevision } from "@/types/revisions";
import { globalStore } from "@/store/store-accessor";
import { fetchRemotePresetsRevisions } from "@/lib/presets/revisions";
import RevisionsPanel from "@/components/Settings/RevisionsPanel.vue";

@Component({
  components: { RevisionsPanel, RevisionsList }
})
export default class PresetsPanelHistoryViewMode extends Vue {
  resourceKey: keyof PresetsRevision = "presets";

  get presets() {
    return globalStore.presets;
  }

  get hasUnsavedChangesPresent() {
    return globalStore.presetsHasUnsavedChangesPresent;
  }

  get fetchRevisionsMethod() {
    return fetchRemotePresetsRevisions;
  }
}
